import { Injectable } from '@angular/core';
import {
  HttpClient
} from '@angular/common/http';

import { ApiClientService } from './../../shared/services/api-client.service';
import { AB_API_REFRESH_SESSION } from './../../shared/constants';
import { Subject } from 'rxjs';
import { tap, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SessionService extends ApiClientService {
  private callDone = new Subject();
  private waitOtherRequest = new Subject();
  private waiting = false;
  private _waitingOtherRequest = false;
  private requests = new Map<string, boolean>();
  constructor(http: HttpClient) {
    super(http, AB_API_REFRESH_SESSION);
  }

  get refreshToken() {
    return this.callDone.asObservable();
  }

  get waitingForRefreshToken() {
    return this.waiting;
  }

  set waitingOtherRequest(value) {
    this._waitingOtherRequest = value;

    if (!value) {
      this.waitOtherRequest.next(true);
      this.waitOtherRequest.complete();
      this.waitOtherRequest = new Subject();
    }
  }

  refreshSession() {
    const refresh = () => {
      this.waiting = true;
      return this.get().pipe(
        tap(
          () => {},
          () => {
            this.refreshTokenOver();
          },
          () => {
            this.refreshTokenOver();
          }
        )
      );
    };

    if (this._waitingOtherRequest) {
      return this.refreshTokenWait(refresh);
    } else {
      return refresh();
    }
  }

  setRequset(req) {
    this.requests.set(req.url, true);
  }

  public chechResponse(req) {
    if (this.requests.has(req.url)) {
      this.requests.delete(req.url);
    }

    if (this.requests.size === 0) {
      this.waitingOtherRequest = false;
    }
  }

  private refreshTokenWait(request) {
    return this.waitOtherRequest.asObservable().pipe(switchMap(request));
  }

  private refreshTokenOver() {
    this.callDone.next(true);
    this.waiting = false;
    this.callDone.complete();
    this.callDone = new Subject();
  }
}
